import axios from "axios";
import {
    getSystemLang
} from "../lang";
let domain  = window.location.protocol+"//"+window.location.host;
if(window.location.hostname=="localhost"){
    axios.defaults.baseURL = '/swd/';
}else{
    // axios.defaults.baseURL = 'https://api.wifigolf.com/api/'; //正式
    axios.defaults.baseURL = 'https://overview.wifigolf.com/api_wifigolf_com/public/index.php/';
}

export default function($url,$param){
    // let lang = getSystemLang();
    // if(lang == 'cn')
    // {
    //     lang = 'zh-cn';
    // }
    // else if(lang == 'en')
    // {
    //     lang = 'en-us';
    // }
    // else
    // {
    //     lang = 'zh-cn';
    // }

    let tparam = [];
    if($param instanceof Object)
    {
        for(let key in $param)
        {
            tparam.push(key+'='+ encodeURIComponent($param[key]));
        }
    }
    $url = $url+'?'+tparam.join("&"); 
    // if(tparam.length > 0)
    // {

    //     $url = lang+'/v1/'+$url+'?'+tparam.join("&"); 
    // }
    // else
    // {
    //     $url = lang+'/v1/'+$url;
    // }
    
    return axios.get($url);
}